import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { IContext } from '@context/models/context';

@Injectable()
export class ContextToHttpParamsService {

  getParams(context: IContext): HttpParams {
    let httpParams = new HttpParams();
    if (context.UserEnteredClientRef !== undefined) { httpParams = httpParams.append('UserEnteredClientRef', String(context.UserEnteredClientRef)); }
    if (context.UnitRef !== undefined) { httpParams = httpParams.append('UnitRef', String(context.UnitRef)); }
    if (context.PropertyRef !== undefined) { httpParams = httpParams.append('PropertyRef', String(context.PropertyRef)); }
    if (context.EstateRef !== undefined) { httpParams = httpParams.append('EstateRef', String(context.EstateRef)); }
    if (context.HeadLeaseRef !== undefined) { httpParams = httpParams.append('HeadLeaseRef', String(context.HeadLeaseRef)); }
    if (context.LeaseRef !== undefined) { httpParams = httpParams.append('LeaseRef', String(context.LeaseRef)); }
    if (context.VacantRef !== undefined) { httpParams = httpParams.append('VacantRef', String(context.VacantRef)); }
    if (context.TenantRef !== undefined) { httpParams = httpParams.append('TenantRef', String(context.TenantRef)); }
    if (context.CreditorUri !== undefined) { httpParams = httpParams.append('CreditorUri', String(context.CreditorUri)); }
    if (context.DebtorUri !== undefined) { httpParams = httpParams.append('DebtorUri', String(context.DebtorUri)); }
    if (context.UserEnteredClientParentRef !== undefined) { httpParams = httpParams.append('UserEnteredClientParentRef', String(context.UserEnteredClientParentRef)); }
    if (context.SupplierRef !== undefined) { httpParams = httpParams.append('SupplierRef', String(context.SupplierRef)); }
    if (context.LandlordRef !== undefined) { httpParams = httpParams.append('LandlordRef', String(context.LandlordRef)); }
    if (context.ManagerCode !== undefined) { httpParams = httpParams.append('ManagerCode', String(context.ManagerCode)); }
    return httpParams;
  }

}
